import { Platform, StyleSheet } from 'react-native'
import { ThemedValues } from 'styles/themed'
import { colorList } from 'utils/colors'
import { topNavigationColors } from 'styles/top-navigation'

export const ThemedTopNavigationStyles = StyleSheet.create({
	container: {
		flexDirection: 'row',
		justifyContent: 'center',
		alignItems: 'center',
		alignContent: 'stretch',
	},
	
	accessory: {
		alignItems: 'center',
		justifyContent: 'center'
	},
	
	accessoryLeft: {
		alignItems: 'flex-start',
		flex: 0,
		paddingLeft: (ThemedValues.marginHorizontal - 4),
		width: 32,
	},
	
	accessoryRight: {
		alignItems: 'flex-end',
		flex: 0,
		paddingRight: (ThemedValues.marginHorizontal - 4),
		width: 32,
	},
	
	titleView: {
		flex: 1,
		alignItems: 'center',
		justifyContent: 'center',
		paddingHorizontal: ThemedValues.marginHorizontal,
		color: colorList.WHITE.primary
	},
	title: {
		color: topNavigationColors.title.dark,
		fontSize: 18,
		fontWeight: '700',
		textAlign: 'center',
	},
	subtitle: {
		color: topNavigationColors.subtitle.dark,
		fontSize: 12,
		fontWeight: '500',
		textAlign: 'center',
	},
	
	// Web
	containerWeb: {
		flex: 1,
		flexDirection: 'row',
		justifyContent: 'center',
		alignItems: 'center',
		alignContent: 'stretch',
		
		width: '100%',
		height: 50,
	},
	accessoryWeb: {
		flex: 0,
		alignSelf: 'stretch',
		alignContent: 'stretch',
		alignItems: 'center',
		justifyContent: 'center',
		minWidth: 50,
	},
	accessoryLeftWeb: {
		//minWidth: 50,
	},
	accessoryRightWeb: {
		//minWidth: 50,
	},
	titleViewWeb: {
		flex: 1,
		
		alignContent: 'stretch',
		alignItems: 'center',
		justifyContent: 'center',
	},
	
	topNavigationContainer: {},
	topNavigation: {
		backgroundColor: 'transparent',
		...Platform.select({
			web: {
				paddingVertical: 2,
				minHeight: 40,
			},
			default: {
				paddingVertical: 0,
				minHeight: 36,
			},
		}),
	}
});
